import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import ExchangeRateFormula from '../../../ExchangeRateFormula/ExchangeRateFormula';

import { TXTWCL_Converted_N0_to_N1 } from './CurrencyConversionDescription.messages.json';
import styles from './CurrencyConversionDescription.scss';

interface Props {
  sourceCurrency: Currency;
  targetCurrency: Currency;
  convertedAmount: number;
  currentAmount: number;
  rate: number;
}

const CurrencyConversionDescription: React.FC<Props> = ({
  sourceCurrency,
  targetCurrency,
  convertedAmount,
  currentAmount,
  rate
}) => {
  if (sourceCurrency === targetCurrency) {
    return null;
  }

  return (
    <span className={styles.extendedDescription}>
      <Translation
        {...TXTWCL_Converted_N0_to_N1}
        values={{
          0: (
            <CurrencyAmount
              currencyDisplay="code"
              currency={sourceCurrency}
              value={currentAmount}
            />
          ),
          1: (
            <CurrencyAmount
              currencyDisplay="code"
              currency={targetCurrency}
              value={convertedAmount}
            />
          )
        }}
      />
      <br />
      <ExchangeRateFormula
        maximumFractionDigits={4}
        sourceAmountInCents={100}
        sourceCurrency={sourceCurrency}
        targetCurrency={targetCurrency}
        rate={rate}
      />
    </span>
  );
};

export default CurrencyConversionDescription;
